import { Outlet } from "react-router-dom";
import UnAuthorizedRoute from "./UnAuthorizedRoute";

const PrivateLayout = () => {
    return <>
        <UnAuthorizedRoute>
            <Outlet />
        </UnAuthorizedRoute>
    </>;
};

export default PrivateLayout;
